module.exports = __webpack_public_path__ + "static/media/logo_pos.84867834.png";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/logo_pos.png
// module id = 289
// module chunks = 0